<div class="cpt-modal revolution-dialog revolution-stepper relative dialog-content-p-0 mat-dialog-actions-pb-20 mat-divider-p-0 ef-scrollbar">
  <button class="dialog-close-button" (click)="dialogRef.close(false)">
    <mat-icon svgIcon="close"></mat-icon>
  </button>

  <h2 class="font-canelablack-primary text-4xl px-6 pt-10 md:px-10 md:pt-10 pb-4" mat-dialog-title>
    <T str="Support and questions about the vehicle"
       key="customerPortal.customer-portal.support.vehicle-questions"
       tags="customer-portal, 3.41"></T>
  </h2>

  <mat-dialog-content class="p-0 ml-2.5 max-h-[none]">
    <div class="px-6 md:px-10">
      <h2 class="appointment-form-title">
        <T str="Choose vehicle"
           key="customerPortal.customer-portal.appointments.choose-vehicle"
           tags="customer-portal, 3.1"></T>
      </h2>
      <customer-portal-vehicle-picker
        [vehicles]="vehicles"
        [loading]="loading"
        [country]="country"
        [showOtherOption]="false"
        (vehicleSelected)="onVehicleSelected($event)">
      </customer-portal-vehicle-picker>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="flex p-0 px-6 md:px-10 mt-5 mb-5">
    <button mat-flat-button mat-button color="secondary"
            class="next revolution w-full md:w-auto"
            [disabled]="!selectedVehicle"
            (click)="onNext()">
      {{ translateShared('next') }}
    </button>
  </mat-dialog-actions>
</div>
